import { REHYDRATE } from 'redux-persist';
import {
  MAX_LISTS_FETCH,
  MAX_LISTS_SET_SEARCH,
  MAX_LISTS_SET_SORT,
  MAX_LISTS_SET_VIEW,
  MAX_LISTS_SET_FILTERS,
  MAX_LISTS_CRUD_MODE
} from '../actions';

const INIT_STATE = {
  list: [],
  grid_options: {
    max_lists: {
      crud_modal: null,
      crud_data: null,
      view: 'list',
      sort: 'asc',
      search: null,
      filters: {}
    }
  }
};

const getKey = (action) => {
  let key = null
  const allKeys = ['max_lists']
  if (action.type.indexOf('MAX_LISTS_') === 0) {
    key = 'max_lists'
  }
  return { key, remaining: allKeys.filter(a => a !== key) }
}

const handler = (state = INIT_STATE, action) => {
  switch (action.type) {
    case MAX_LISTS_FETCH.REQUEST: {
      return { ...state, list: [] }
    }
    case MAX_LISTS_FETCH.SUCCESS: {
      return { ...state, list: action.payload }
    }
    case MAX_LISTS_SET_SEARCH.REQUEST: {
      const { key } = getKey(action)
      return { ...state, grid_options: {
        ...state.grid_options,
        [key]: {
          ...state.grid_options[key],
          search: action.payload.query
        }
      } }
    }
    case MAX_LISTS_SET_SORT.REQUEST: {
      const { key } = getKey(action)
      return { ...state, grid_options: {
        ...state.grid_options,
        [key]: {
          ...state.grid_options[key],
          sort: action.payload
        }
      } }
    }
    case MAX_LISTS_SET_VIEW.REQUEST: {
      const { key } = getKey(action)
      return { ...state, grid_options: {
        ...state.grid_options,
        [key]: {
          ...state.grid_options[key],
          view: action.payload
        }
      } }
    }
    case MAX_LISTS_SET_FILTERS.REQUEST: {
      const { key, remaining: [remKey1, remKey2, remKey3] } = getKey(action)
      return { ...state, grid_options: {
        ...state.grid_options,
        [key]: {
          ...state.grid_options[key],
          filters: action.payload
        },
        [remKey1]: {
          ...state.grid_options[key],
          filters: {}
        },
        [remKey2]: {
          ...state.grid_options[key],
          filters: {}
        },
        [remKey3]: {
          ...state.grid_options[key],
          filters: {}
        },
      } }
    }
    case MAX_LISTS_CRUD_MODE.REQUEST: {
      const { key } = getKey(action)
      const { mode, data } = action.payload
      return { ...state, grid_options: {
        ...state.grid_options,
        [key]: {
          ...state.grid_options[key],
          crud_modal: mode,
          crud_data: data||null
        }
      } }
    }
    case REHYDRATE: {
      return INIT_STATE
    }
    default: return { ...state };
  }
}

export default handler
